export default {
  web: [
    {
      action: 'mdi-home-outline',
      title: 'Trang chủ',
      to: '/',
    },
    {
      action: 'mdi-map',
      title: 'Bản đồ nông nghiệp',
      to: '/agri-map',
    },
    {
      action: 'mdi-sprout-outline',
      title: 'Sản phẩm',
      to: '/products',
    },
    {
      action: 'mdi-factory',
      title: 'Các cơ sở SX, KD',
      to: '/business',
    },
    // {
    //   action: 'mdi-human-greeting-proximity',
    //   title: 'Tin cung-cầu',
    //   to: '/trades',
    // },
    {
      action: 'mdi-finance',
      title: 'Giá nông sản',
      to: '/market-price',
    },
    {
      action: 'mdi-web',
      title: 'Thông tin',
      to: '/news',
    },
    {
      action: 'mdi-comment-question',
      title: 'Hỏi đáp kỹ thuật',
      to: '/supports',
    },
    {
      action: 'mdi-thermometer-water',
      title: 'Quan trắc',
      to: '/environment',
    },
    {
      action: 'mdi-email-arrow-right-outline',
      title: 'Liên hệ',
      to: '/contact',
    },
  ],
  admin: [
    {
      action: 'mdi-view-dashboard-outline',
      title: 'Tổng quan',
      to: '/admin/dashboard'
    },
    {
      action: 'mdi-barcode-scan',
      title: 'Sản phẩm truy xuất',
      can: 'san-pham-thao-tac',
      items: [
        {
          title: 'Loại sản phẩm',
          to: '/admin/product-types'
        },
        {
          title: 'Kho, xưởng',
          to: '/admin/warehouses'
        },
        {
          title: 'Cơ sở sản xuất',
          to: '/admin/businesses'
        },
        {
          title: 'Nhà phân phối',
          to: '/admin/coopes'
        },
        {
          title: 'Sản phẩm',
          to: '/admin/products'
        }
      ]
    },
    {
      action: 'mdi-seal',
      title: 'Sản phẩm chuỗi',
      to: '/admin/product-chains',
      subheader: 'Quản lý',
    },
    {
      action: 'mdi-newspaper-variant-multiple',
      title: 'Tin tức, sự kiện',
      can: 'tin-tuc-thao-tac',
      items: [
        {
          title: 'Loại thông tin',
          to: '/admin/post-types'
        },
        {
          title: 'Thông tin',
          to: '/admin/news'
        }
      ]
    },
    {
      action: 'mdi-chart-timeline-variant-shimmer',
      title: 'Thị trường',
      items: [
        {
          title: 'Nhóm giá',
          to: '/admin/market-prod-groups'
        },
        {
          title: 'Loại giá',
          to: '/admin/market-prod-types'
        },
        {
          title: 'Mặt hàng',
          to: '/admin/market-products'
        },
        {
          title: 'Giá cả',
          to: '/admin/market-prices'
        }
      ]
    },
    // {
    //     action: 'mdi-compare-horizontal',
    //     title: 'Tin cung cầu',
    //     to: '/admin/trades',
    //     can: 'cung-cau-xem',
    // },
    {
      action: 'mdi-email-arrow-right-outline',
      title: 'Liên hệ, phản hồi',
      to: '/admin/contacts',
      can: 'lien-he-xem',
    },
    {
      action: 'mdi-comment-question-outline',
      title: 'Hỏi và đáp',
      can: 'hoi-dap-thao-tac',
      items: [
        {
          title: 'Lĩnh vực',
          to: '/admin/support-branch'
        },
        {
          title: 'Chuyên gia',
          to: '/admin/experts',
        },
        {
          title: 'Lịch sử',
          to: '/admin/supports'
        },
        {
          title: 'Cuộc gọi nhỡ',
          to: '/admin/misscalls'
        }
      ]
    },
    {
      action: 'mdi-file-tree',
      title: 'Đơn vị quản lý',
      to: '/admin/managements',
      can: 'don-vi-quan-ly-xem'
    },
    {
      action: 'mdi-shield-account',
      title: 'Truy cập',
      subheader: 'Hệ thống',
      can: 'truy-cap-thao-tac',
      items: [
        {
          title: 'Nhật ký sử dụng',
          to: '/admin/activity-logs'
        },
        {
          title: 'Người dùng',
          to: '/admin/users'
        },
        {
          title: 'Vai trò (Roles)',
          to: '/admin/roles',
          can: 'vai-tro-xem'
        },
        {
          title: 'Chức năng',
          to: '/admin/permissions',
          can: 'chuc-nang-xem'
        }
      ]
    },
    {
      action: 'mdi-file-tree',
      title: 'Đơn vị hành chính',
      can: 'hanh-chinh-thao-tac',
      items: [
        {
          title: 'Tỉnh, Thành phố',
          to: '/admin/unit/province'
        },
        {
          title: 'Quận, huyện',
          to: '/admin/unit/district'
        },
        {
          title: 'Xã, Phường, Thị trấn',
          to: '/admin/unit/ward'
        }
      ]
    },
    {
      action: 'mdi-archive-sync-outline',
      title: 'Đồng bộ CSDL',
      to: '/admin/sync-data',
      can: 'thiet-lap-thao-tac',
    },
    {
      action: 'mdi-tune-vertical',
      title: 'Thiết lập',
      can: 'thiet-lap-thao-tac',
      items: [
        {
          title: 'Thông tin hệ thống',
          to: '/admin/system'
        },
        {
          title: 'Web liên kết',
          to: '/admin/web-links'
        },
        {
          title: 'Tham số hệ thống',
          to: '/admin/options',
          can: 'tuy-chon-xem'
        },
        {
          title: 'Sao lưu dữ liệu',
          to: '/admin/backup',
          can: 'sao-luu-xem'
        },
        {
          title: 'Changelog',
          to: '/admin/changelogs'
        }
      ]
    }
  ] 
};